"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RawEnrollModal = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _Icon = _interopRequireDefault(require("@concur/nui-widgets/lib/Icon/Icon"));
var _Modal = _interopRequireDefault(require("@concur/nui-widgets/lib/Modal/Modal"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
var _listingModule = require("./listingModule");
var _listingsModule = require("../listings/listingsModule");
var _utils = require("../utils");
var AnalyticsModule = _interopRequireWildcard(require("../analytics/modules/AnalyticsModule"));
var _analytics = require("../constants/analytics");
var _this = void 0;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var RawEnrollModal = exports.RawEnrollModal = function RawEnrollModal(_ref) {
  var _listingData$listingI, _listingData$listingI2, _listingData$listingI3, _listingData$listingI4, _listingData$listingI5, _listingData$listingI6;
  var isEnrollModalOpen = _ref.isEnrollModalOpen,
    toggle = _ref.toggle,
    modalNames = _ref.modalNames,
    listingId = _ref.listingId,
    v1ListingId = _ref.v1ListingId,
    checkForConnection = _ref.checkForConnection,
    updateConnectionOnIndex = _ref.updateConnectionOnIndex,
    trackButtonClick = _ref.trackButtonClick,
    companyUUID = _ref.companyUUID,
    listingData = _ref.listingData,
    formatter = _ref.formatter,
    _ref$userBetas = _ref.userBetas,
    userBetas = _ref$userBetas === void 0 ? {} : _ref$userBetas;
  /*
  * This function is a hack. Code in CTE looks for the existance of
  * this function. If it exists, the styles will work without us needing
  * to hack them in. If removed, all hell breaks loose. For the love
  * of God, do not remove.
  */
  if ((0, _utils.canUseDOM)()) {
    window.otHidePopupDialog = function () {
      // No-op
    };
  }
  var useNewModalLogic = userBetas['new-mtn-connect-modal'] && !!((_listingData$listingI = listingData[listingId]) !== null && _listingData$listingI !== void 0 && (_listingData$listingI2 = _listingData$listingI.data) !== null && _listingData$listingI2 !== void 0 && (_listingData$listingI3 = _listingData$listingI2.core) !== null && _listingData$listingI3 !== void 0 && _listingData$listingI3.customEnrollUrl);
  var listingName;
  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }
  var toggleThisModal = function toggleThisModal() {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.modal.enroll, _analytics.button.x],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    toggle(modalNames.enroll);
  };
  if (!(0, _utils.canUseDOM)()) {
    return /*#__PURE__*/_react.default.createElement("span", null, "JavaScript is Required to Enroll");
  }
  if (useNewModalLogic) {
    (0, _react.useEffect)(function () {
      if (!window.Appcenter) {
        window.Appcenter = {};
      }
      window.Appcenter.modal = {
        onClose: toggleThisModal,
        onSuccess: function onSuccess() {
          checkForConnection(listingId, v1ListingId);
          updateConnectionOnIndex(listingId, true);
        }
      };
      return function onComponentUnmount() {
        var _window, _window$Appcenter;
        if ((_window = window) !== null && _window !== void 0 && (_window$Appcenter = _window.Appcenter) !== null && _window$Appcenter !== void 0 && _window$Appcenter.modal) {
          delete window.Appcenter.modal;
        }
      };
    });
    (0, _react.useEffect)(function () {
      if (isEnrollModalOpen) {
        _nuiLogger.default.info({
          description: 'Enroll modal launched',
          category: 'enroll-modal-launch'
        });
      }
    }, [isEnrollModalOpen]);
  }
  var accessIframeEl = function accessIframeEl(selector) {
    var getIframeEl = function getIframeEl() {
      return document.getElementById('autoconnectframe').contentWindow.document;
    };
    var el = getIframeEl().querySelector(selector);
    var _listener = function listener(element, cb) {
      element.addEventListener('click', function (event) {
        cb(element, event);
      });
      return {
        addEventListener: _listener.bind(_this, element)
      };
    };
    var adjustElement = function adjustElement(element, cb) {
      cb(element);
    };
    return {
      addEventListener: _listener.bind(_this, el),
      element: adjustElement.bind(_this, el)
    };
  };
  if (isEnrollModalOpen && !useNewModalLogic) {
    requestAnimationFrame(function () {
      var iFrame = document.getElementById('autoconnectframe');
      if (iFrame) {
        iFrame.onload = function () {
          accessIframeEl('a.cnqr-connect-appcenter-autoconnect-button-cancel').addEventListener(function () {
            toggleThisModal();
          });
        };
      }
    });
  }
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    show: isEnrollModalOpen,
    onHide: toggleThisModal,
    "aria-label": formatter.formattedMessage({
      id: 'EnrollModalLabel'
    }),
    size: useNewModalLogic ? 'lg' : 'xl',
    modalContainerClassName: "modal-container ".concat(useNewModalLogic ? '' : 'legacy-enroll-modal-container')
  }, useNewModalLogic ? /*#__PURE__*/_react.default.createElement("iframe", {
    style: {
      height: '100%',
      width: '100%',
      minHeight: '582px',
      border: 'none'
    },
    title: "enroll-modal-contents",
    name: "autoconnect",
    id: "autoconnectframe",
    src: (_listingData$listingI4 = listingData[listingId]) === null || _listingData$listingI4 === void 0 ? void 0 : (_listingData$listingI5 = _listingData$listingI4.data) === null || _listingData$listingI5 === void 0 ? void 0 : (_listingData$listingI6 = _listingData$listingI5.core) === null || _listingData$listingI6 === void 0 ? void 0 : _listingData$listingI6.customEnrollUrl,
    "data-testid": "EnrollModal-new-modal-iframe",
    sandbox: ""
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-10 col-xs-offset-1"
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    title: "enroll-modal-contents",
    name: "autoconnect",
    style: {
      border: 'none',
      overflow: 'scroll'
    },
    width: "100%",
    height: "580px",
    id: "autoconnectframe",
    src: "/UI/appcenter/AutoConnect?source=ipm",
    "data-testid": "EnrollModal-old-modal-iframe",
    sandbox: ""
  })), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    iconName: "close",
    size: "md",
    className: "close-tandc-modal",
    onClick: toggleThisModal
  })));
};
RawEnrollModal.propTypes = {
  formatter: _propTypes.default.object,
  isEnrollModalOpen: _propTypes.default.bool.isRequired,
  toggle: _propTypes.default.func.isRequired,
  modalNames: _propTypes.default.object.isRequired,
  listingId: _propTypes.default.string.isRequired,
  v1ListingId: _propTypes.default.string.isRequired,
  updateConnectionOnIndex: _propTypes.default.func.isRequired,
  checkForConnection: _propTypes.default.func.isRequired,
  trackButtonClick: _propTypes.default.func,
  companyUUID: _propTypes.default.string,
  listingName: _propTypes.default.string,
  listingData: _propTypes.default.object,
  userBetas: _propTypes.default.object
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isEnrollModalOpen: state.listing.isEnrollModalOpen,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    companyUUID: state.userPrefs.companyUUID,
    listingData: state.listing,
    userBetas: state.betas || {}
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  toggle: _listingModule.toggleModal,
  checkForConnection: _listingModule.checkForConnection,
  updateConnectionOnIndex: _listingsModule.updateConnectedStatus,
  trackButtonClick: AnalyticsModule.buttonClickDispatch
})((0, _nuiIntlRuntime.withFormatter)(RawEnrollModal));